import { API_URL } from '../../../app-config/constants';
import AuditRecordMediumDto from '../../../types/AuditRecordMediumDto';
import { post } from '../request';

interface Query {
    companyId: string;

    executor?: string;
    target?: string;
    category?: number;
    type?: number;
    container?: string;

    dateStart?: number;
    dateEnd?: number;

    cursor?: string;

    limit: number;
}

getLogs.operation = 'READ';
getLogs.idFrom = 'ARGS';
export function getLogs(query: Query) {
    return post<AuditRecordMediumDto>(`${API_URL}/audit-record`, { postData: query });
}
